import * as React from 'react'
import InfoAppBar from '../../components/SchoolHomepage/DefaultHomepage/InfoAppBar'
import { AnalyticService } from '../../lib/analytics/analyticService'
import { Button, Typography, useMediaQuery } from '@mui/material'
import SchoolHomepageQuizListComponent from '../../components/Assessments/SchoolHomepageQuizListComponent'
import { ISchool } from '../../interfaces/school.interface'
import { ICourse } from '../../interfaces/ICourse'
import { useTheme } from '@mui/material/styles'
import SchoolHomePageNotificationBanner from '@/components/SchoolHomepage/DefaultHomepage/SchoolHomePageNotificationBanner'

interface IQuizHomepageProps {
  schoolDetails: ISchool
  courses: ICourse[]
}

const SchoolHomepageQuizView = (props: IQuizHomepageProps) => {
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const [useBackgroundImage] = React.useState(
    !props.schoolDetails?.hide_school_banner &&
      props.schoolDetails?.background_image,
  )

  React.useEffect(() => {
    AnalyticService.onSchoolVisit({ school_id: props.schoolDetails._id })
  }, [])

  return (
    <div style={{ background: '#131313' }}>
      <InfoAppBar
        school_details={props.schoolDetails}
        defaultStyle={{ backgroundColor: '#131313' }}
        appbarStyle={{ boxShadow: 'none' }}
        linkStyle={{ color: '#fafafaa1' }}
      />
      <SchoolHomePageNotificationBanner schoolDetails={props.schoolDetails} />

      <div
        style={
          useBackgroundImage
            ? {
                display: 'flex',
                minHeight: '400px',
                width: '100%',
                alignItems: 'center',
                backgroundImage: props.schoolDetails?.background_image
                  ? `linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('${props.schoolDetails?.background_image}')`
                  : "linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('/static/img/bg_img_3.jpeg')",
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                color: '#fff',
              }
            : {
                padding: '100px 20px',
                backgroundColor: '#1c1d1f',
                color: '#fff',
                minHeight: '300px',
              }
        }
      >
        <div
          style={{
            minHeight: '150px',
            width: '100%',
            position: 'relative',
            justifyContent: 'center',
            display: 'flex',
          }}
        >
          <div
            style={{
              minWidth: '40%',
              maxWidth: '300px',
              margin: 'auto',
            }}
          >
            <Typography
              gutterBottom={true}
              variant={isSmallScreen ? 'h4' : 'h3'}
              style={{
                marginTop: '40px',
                wordWrap: 'break-word',
                textAlign: 'center',
              }}
            >
              <b>Quizzes in {props.schoolDetails.name} </b>
            </Typography>
            <Typography
              style={{
                marginBottom: '40px',
                wordWrap: 'break-word',
                textAlign: 'center',
              }}
              gutterBottom={true}
              variant={isSmallScreen ? 'body2' : 'body1'}
              paragraph={true}
            >
              {props.schoolDetails.tagline}
            </Typography>
            <Typography style={{ marginTop: '20px' }} align={'center'}>
              <Button variant={'contained'} size={'large'} href={'/'}>
                Go to course list
              </Button>
            </Typography>
          </div>
        </div>
      </div>
      <div>
        <SchoolHomepageQuizListComponent
          courses={props.courses}
          schoolDetails={props.schoolDetails}
        />
      </div>

      <div style={{ height: '40px' }} />
    </div>
  )
}

export default SchoolHomepageQuizView
